module.exports = __webpack_public_path__ + "static/portfel-b94018641120325a0a2eed901226d336.png";